import { differenceInMinutes, parseISO } from '@e3dc-react/shell/Libs/date'
export const ONLINE_THRESHOLD_MIN = 15

/**
 * Returns if a storage is online based on a timestamp
 */
export const determineIsStorageOnline = (timestamp?: string): boolean => {
  if (!timestamp) return false
  const lastSeen = parseISO(timestamp)
  const now = Date.now()

  const isOnline = differenceInMinutes(now, lastSeen) < ONLINE_THRESHOLD_MIN
  return isOnline
}
